import { CHECKOUT_URL } from "../data/landing";
const attributionKeys = ["utm_source","utm_medium","utm_campaign","utm_term","utm_content","utm_id","fbclid","gclid","gbraid","wbraid","ttclid","msclkid","src","sck"];
export function getCheckoutUrl(search = typeof window !== "undefined" ? window.location.search : "") {
 const url = new URL(CHECKOUT_URL);
 const params = new URLSearchParams(search);
 attributionKeys.forEach(key => { const value=params.get(key); if(value) url.searchParams.set(key,value); });
 return url.toString();
}
